import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';

import { fromRole } from '../reducers';
import { Role } from '../models';

export const getRoleRootState: MemoizedSelector<
unknown,
fromRole.State
> = createFeatureSelector<fromRole.State>('role');
export const getRoleState: MemoizedSelector<unknown, fromRole.State> = createSelector(
  getRoleRootState,
  (state) => state
);

const roleSelectors = fromRole.roleAdapter.getSelectors(getRoleState);
export const getAllRoleItems: (state: unknown) => Role[] = roleSelectors.selectAll;
export const getRoleEntities: (state: unknown) => Dictionary<Role> = roleSelectors.selectEntities;

/**
 * Selector to return the loaded property of the state
 */
export const getRolesLoaded: MemoizedSelector<unknown, boolean> = createSelector(
  getRoleState,
  fromRole.getRolesLoaded
);
export const getRolesLoading: MemoizedSelector<unknown, boolean> = createSelector(
  getRoleState,
  fromRole.getRolesLoading
);
